import React from 'react';
import {connect} from 'react-redux';
import { actions } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Store from './store';
import AddStore from './add-store';
import {history} from '../../store';
import { tradeSiteEnabled } from '../../utils/toggles';

const useRegistrationPage = (registration) => {
  if (tradeSiteEnabled()) {
    return history.location.pathname.startsWith('/registration/');
  }

  return registration.pending && !registration.internal;
};

const StoreList = ({
  stores, vouchers, fetched, fetching, dispatch, registration
}) => {
  const onAddStoreClicked = () => {
    if (useRegistrationPage(registration)) {
      dispatch(actions.reset('deep.registration.outlet_validation'));
      dispatch(actions.reset('deep.yourStore'));
      history.push('/registration/outlet');
    } else {
      dispatch({type: 'START_REGISTRATION_INTERNAL'});
      history.push('/outlet');
    }
  };

  if (!fetched && fetching) {
    return (<h1>Loading...</h1>);
  }

  return (
    <div className="store-list">
      <Row>
        <Col mdPush={8} md={4}>
          <Row>
            <AddStore key="-1" onAddStoreClicked={onAddStoreClicked} registration={registration} />
          </Row>
        </Col>
        <Col mdPull={4} md={8}>
          <Row>
            {stores.map(store => (
              <Store
                key={store.id}
                outlet={store}
                registration={registration}
                vouchers={vouchers}
              />
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default connect()(StoreList);



// WEBPACK FOOTER //
// ./src/components/store-summary/store-list.jsx